import { render, staticRenderFns } from "./InterfaceDepotTransactions.vue?vue&type=template&id=621f2740&scoped=true"
import script from "./InterfaceDepotTransactions.vue?vue&type=script&lang=js"
export * from "./InterfaceDepotTransactions.vue?vue&type=script&lang=js"
import style0 from "./InterfaceDepotTransactions.vue?vue&type=style&index=0&id=621f2740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621f2740",
  null
  
)

export default component.exports